import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import PriceBookTable from './PriceBookTable';
import { storeWithExpiration } from '../../utils/common';

export class PriceBookTableContainer extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    formValues: PropTypes.object,
    dialog: PropTypes.object.isRequired,
    form: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    isCRM: PropTypes.bool.isRequired,
    initialValues: PropTypes.object.isRequired,
    tableContents: PropTypes.object.isRequired,
    revShare: PropTypes.number.isRequired,
    openDialogFunction: PropTypes.func.isRequired,
    closeDialogFunction: PropTypes.func.isRequired,
    updatePriceAction: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    formValues: null,
  };

  state = {
    updating: false,
  };

  toggleForm = () => {
    const { updating } = this.state;

    if (updating) {
      this.setState({
        updating: false,
      });
    } else {
      this.setState({
        updating: true,
      });
    }
  };

  saveChangesFunction = params => {
    const { closeDialogFunction } = this.props;
    this.submitNewCosts(params);
    closeDialogFunction('priceDialog');
    this.toggleForm();
  };

  submitNewCosts = params => {
    const { accountId, updatePriceAction, initialValues } = this.props;
    const token = storeWithExpiration.get('token');
    const paramKeys = Object.keys(params);
    const numKeys = paramKeys.length / 2;

    // Splices the array so we only iterate over keys associated
    // with the 'cost' fields
    // The floor value needs to be included in the API call,
    // even if the user is not an admin
    paramKeys.splice(numKeys, numKeys);

    paramKeys.forEach(keyNum => {
      if (
        params[keyNum] !== initialValues[keyNum] ||
        params[keyNum.concat('_floor')] !== initialValues[keyNum.concat('_floor')]
      ) {
        const priceObject = {
          cost: Number.parseFloat(params[keyNum]),
          floor: Number.parseFloat(params[keyNum.concat('_floor')]),
        };
        // If the price or floor has changed, update
        updatePriceAction(accountId, keyNum, priceObject, token);
      }
    });
  };

  render() {
    const {
      accountId,
      formValues,
      dialog,
      form,
      handleSubmit,
      invalid,
      isCRM,
      isSuperAdmin,
      initialValues,
      tableContents,
      revShare,
      submitting,
      closeDialogFunction,
      openDialogFunction,
    } = this.props;
    const { updating } = this.state;

    return (
      <PriceBookTable
        accountId={accountId}
        formValues={formValues}
        dialog={dialog}
        form={form}
        handleSubmit={handleSubmit}
        invalid={invalid}
        initialValues={initialValues}
        isCRM={isCRM}
        isSuperAdmin={isSuperAdmin}
        buckets={tableContents}
        revShare={revShare}
        submitting={submitting}
        saveChangesFunction={this.saveChangesFunction}
        closeDialogFunction={closeDialogFunction}
        openDialogFunction={openDialogFunction}
        toggleForm={this.toggleForm}
        updating={updating}
      />
    );
  }
}

const validate = values => {
  const errors = {};
  const valKeys = Object.keys(values);
  valKeys.forEach(field => {
    if (
      !values[field] ||
      (values[field] === '' || Number.isNaN(Number.parseFloat(values[field])))
    ) {
      errors[field] = 'Input is not a valid number';
    }
  });
  return errors;
};

const PriceBookTableContainerRF = reduxForm({
  validate,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(PriceBookTableContainer);

const mapStateToProps = (state, ownProps) => {
  const { tableContents } = ownProps;
  const form = 'pricebookForm';
  const formValues = getFormValues(form)(state);
  const initialValues = {};

  tableContents.forEach(item => {
    const itemString = item.id.toString();
    initialValues[itemString] = item.cost.toFixed(2);
    initialValues[itemString.concat('_floor')] = item.floor.toFixed(2);
  });

  return { form, initialValues, formValues };
};

export default connect(mapStateToProps)(PriceBookTableContainerRF);
